/* DESCONEXIÓN — animaciones ligeras. Solo se activa si <html> tiene .dx-anim (lo pone dx-estilos
   cuando el sistema no pide reducir movimiento). Todo con transform / opacity / clip-path. */
(() => {
  const html = document.documentElement;
  window.dxMotionListo = true;
  if (!html.classList.contains('dx-anim') || !('IntersectionObserver' in window)) {
    html.classList.remove('dx-anim');
    return;
  }

  /* Titular del hero: palabras línea a línea + frase en acento a máquina de escribir */
  const RETRASO_LINEA = 110;
  const RETRASO_LETRA = 42;

  function partirTitular(h1) {
    if (h1.dataset.dxPartido) return;
    const acento = h1.querySelector('em');
    const hero = h1.closest('.dx-hero') || h1;
    const palabras = [];

    for (const nodo of [...h1.childNodes]) {
      if (nodo.nodeType !== Node.TEXT_NODE || !nodo.textContent.trim()) continue;
      const frag = document.createDocumentFragment();
      nodo.textContent.split(/(\s+)/).forEach((trozo) => {
        if (!trozo) return;
        if (/^\s+$/.test(trozo)) {
          frag.append(trozo);
          return;
        }
        const caja = document.createElement('span');
        caja.className = 'dx-linea';
        const dentro = document.createElement('span');
        dentro.textContent = trozo;
        caja.append(dentro);
        palabras.push(caja);
        frag.append(caja);
      });
      nodo.replaceWith(frag);
    }

    let lineas = 0;
    let ultimoTop = null;
    for (const caja of palabras) {
      const top = caja.offsetTop;
      if (ultimoTop !== null && top - ultimoTop > 4) lineas++;
      ultimoTop = top;
      caja.style.setProperty('--dx-d', `${lineas * RETRASO_LINEA}ms`);
    }
    const inicioEscritura = palabras.length ? (lineas + 1) * RETRASO_LINEA + 250 : 0;

    if (acento) {
      const texto = acento.textContent;
      const oculto = document.createElement('span');
      oculto.className = 'dx-solo-lector';
      oculto.textContent = texto;
      const visible = document.createElement('span');
      visible.setAttribute('aria-hidden', 'true');
      const letras = [...texto.trimEnd()];
      letras.forEach((letra, i) => {
        const s = document.createElement('span');
        s.className = i === letras.length - 1 ? 'dx-letra dx-letra--ultima' : 'dx-letra';
        s.textContent = letra;
        s.style.setProperty('--dx-d', `${inicioEscritura + i * RETRASO_LETRA}ms`);
        visible.append(s);
      });
      visible.style.setProperty('--dx-paso', `${RETRASO_LETRA}ms`);
      acento.replaceChildren(oculto, visible);
      hero.style.setProperty('--dx-fin', `${inicioEscritura + texto.length * RETRASO_LETRA}ms`);
    } else {
      hero.style.setProperty('--dx-fin', `${inicioEscritura}ms`);
    }

    h1.dataset.dxPartido = 'true';
  }

  /* Aparición al hacer scroll, una sola vez, escalonada por lote */
  const ESCALON = 70;
  const MAX_ESCALONES = 5;
  /* Un elemento oculto con clip-path no cuenta como visible para el observer: se vigila su contenedor */
  const objetivos = new Map();

  const observadorEntrada = new IntersectionObserver(
    (entradas) => {
      const visibles = entradas
        .filter((e) => e.isIntersecting)
        .map((e) => {
          observadorEntrada.unobserve(e.target);
          const el = objetivos.get(e.target) || e.target;
          objetivos.delete(e.target);
          return el;
        })
        .sort((a, b) => (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1));
      visibles.forEach((el, i) => {
        el.style.setProperty('--dx-retraso', `${Math.min(i, MAX_ESCALONES) * ESCALON}ms`);
        el.classList.add('dx-visible');
      });
    },
    { rootMargin: '0px 0px -12% 0px', threshold: 0.12 }
  );

  /* Parallax ligero de los números de producto: solo mientras están en pantalla */
  const numerosActivos = new Set();
  let pendiente = false;

  function moverNumeros() {
    pendiente = false;
    const mitad = window.innerHeight / 2;
    numerosActivos.forEach((el) => {
      const r = el.parentElement.getBoundingClientRect();
      const desplazamiento = Math.max(-28, Math.min(28, (r.top + r.height / 2 - mitad) * -0.12));
      el.style.transform = `translate3d(0, ${desplazamiento.toFixed(1)}px, 0)`;
    });
  }

  function pedirFrame() {
    if (!pendiente && numerosActivos.size) {
      pendiente = true;
      requestAnimationFrame(moverNumeros);
    }
  }

  const observadorParallax = new IntersectionObserver((entradas) => {
    entradas.forEach((e) => (e.isIntersecting ? numerosActivos.add(e.target) : numerosActivos.delete(e.target)));
    pedirFrame();
  });

  /* Franja en movimiento: se pausa fuera de pantalla para no gastar batería */
  const observadorFranja = new IntersectionObserver((entradas) => {
    entradas.forEach((e) => e.target.toggleAttribute('data-dx-en-pantalla', e.isIntersecting));
  });

  function iniciar(raiz = document) {
    raiz.querySelectorAll('.dx-hero__titulo').forEach(partirTitular);
    raiz.querySelectorAll('[data-dx-revelar]:not(.dx-visible)').forEach((el) => {
      const vigilado = el.dataset.dxRevelar === 'mascara' && el.parentElement ? el.parentElement : el;
      if (vigilado !== el) objetivos.set(vigilado, el);
      observadorEntrada.observe(vigilado);
    });
    raiz.querySelectorAll('.dx-prod__fondo').forEach((el) => observadorParallax.observe(el));
    raiz.querySelectorAll('.dx-franja').forEach((el) => observadorFranja.observe(el));
  }

  window.addEventListener('scroll', pedirFrame, { passive: true });
  window.addEventListener('resize', pedirFrame, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => iniciar());
  } else {
    iniciar();
  }

  /* Editor de temas: volver a enganchar al recargar una sección */
  document.addEventListener('shopify:section:load', (e) => iniciar(e.target));
})();
